import {
  HttpInterceptorFn
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const _authService: AuthService = inject(AuthService);
  if (req.url.startsWith(environment.api.url)) {
    let token = _authService.getToken();
    if(_authService.isValidToken()){
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }
  return next(req);
};